import script from "./AlunosAtivos.vue?vue&type=script&setup=true&lang=js"
export * from "./AlunosAtivos.vue?vue&type=script&setup=true&lang=js"

import "./AlunosAtivos.vue?vue&type=style&index=0&id=6870e481&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6870e481"]])

export default __exports__